"use client"

import { Cta_background_image, CTA_boxed } from "@/types/GetHomePageLayoutApiType"
import BackgroundImageCTA from "./BackgroundImageCTA"
import BoxedCTA from "./BoxedCTA"
import CenterAlignedCTA from "./CenterAlignedCTA"

interface CTAindexProps {
  type: string
  CTA_data: Cta_background_image | CTA_boxed
}

const mapToBackgroundImageProps = (data: Cta_background_image) => ({
  image_url: data.backgroundImage?.url ?? "",
  title: data.title,
  description: data.description,
  btn_text: data.buttonText,
  btn_link: data.buttonLink,
})

const mapToBoxedProps = (data: CTA_boxed) => ({
  description: data.description,
  btn_text: data.buttonText,
  btn_link: data.buttonLink,
  backgroundColor: data.backgroundColor,
  title:data?.title
})

const CTAindex = ({ type, CTA_data }: CTAindexProps) => {

  if (type === "background-image" && "backgroundImage" in CTA_data) {
    return <BackgroundImageCTA {...mapToBackgroundImageProps(CTA_data)} />
  }

  if (type === "boxed" && "backgroundColor" in CTA_data) {
    return <BoxedCTA {...mapToBoxedProps(CTA_data)} />
  }

  if (type === "center-aligned-boxed" && "backgroundColor" in CTA_data) {
    return <CenterAlignedCTA {...mapToBoxedProps(CTA_data)} />
  }

  return null
}

export default CTAindex
